<template>
  <div class="customer-rule-content" v-loading="loading">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="rule" /> Rules
      </div>
      <div>
        <el-button type="primary" v-if="isCreate" @click="cretaeRules" :loading="submitting">Create rule</el-button>
      </div>
      <el-form
        ref="settingForm"
        :model="settingForm"
        label-width="180px"
        size="mini"
        v-if="action === 'edit'"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-bottom"></i> Payin</span>
              </div>
              <div>
                <el-form-item label="Mode">
                  <el-switch
                    v-model="settingForm.payin.mode"
                    active-text="Active"
                    inactive-text="Passive"
                    active-value="active"
                    inactive-value="passive"
                  ></el-switch>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payin.transactionCheck"
                    >Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Blacklist">
                  <el-checkbox
                    v-model="settingForm.payin.Blacklist"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Check">
                  <el-checkbox
                    v-model="settingForm.payin.volumeCheck"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Criteria">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.volumeCratirea"
                  ></el-input>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payin.pastTransactionCheck"
                    >Past Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Total Amount">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.totalVolumes"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Diligent Transaction ">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.totalTransactions"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Scope Date">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.scopeDate"
                  ></el-input>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-top"></i> Payout</span>
              </div>
              <div>
                <el-form-item label="Mode">
                  <el-switch
                    v-model="settingForm.payout.mode"
                    active-text="Active"
                    inactive-text="Passive"
                    active-value="active"
                    inactive-value="passive"
                  ></el-switch>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payout.transactionCheck"
                    >Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Amount Check">
                  <el-checkbox
                    v-model="settingForm.payout.volumeCheck"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Criteria">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.volumeCratirea"
                  ></el-input>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payout.pastTransactionCheck"
                    >Past Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Total Amount">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.totalVolumes"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Diligent Transaction ">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.totalTransactions"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Scope Date">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.scopeDate"
                  ></el-input>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <div style="margin-top: 20px" class="text-center">
              <el-button type="primary" @click="onSubmit" :loading="submitting"
                >Submit</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCustomRules, postCustomRules, putCustomRules } from "@/api/firewall-rule";
export default {
  props: {
    plusUID: String
  },
  data() {
    return {
      loading: false,
      submitting: false,
      isCreate: false,
      action: "create",
      settingForm: {
        payin: {
          mode: "active",
          transactionCheck: true,
          volumeCheck: true,
          volumeCratirea: 500,
          pastTransactionCheck: true,
          scopeDate: 7,
          totalVolumes: 5000,
          totalTransactions: 5000,
          Blacklist: true,
        },
        payout: {
          mode: "active",
          transactionCheck: true,
          volumeCheck: true,
          volumeCratirea: 500,
          pastTransactionCheck: true,
          scopeDate: 7,
          totalVolumes: 5000,
          totalTransactions: 5000,
        },
      },
    };
  },
  methods: {
    getMainRule() {
      this.isCreate = false;
      this.loading = true;
      getCustomRules(this.plusUID).then(({ result, data }) => {
        this.loading = false;
        if (result && data) {
          this.action = "edit"
          this.settingForm = data.config;
        }else{
          this.isCreate = true;
          this.action = "create"
        }
      });
    },
    getFormData(){
      const cloneData = JSON.parse(JSON.stringify(this.settingForm));
      Object.keys(cloneData.payin).forEach((key) => {
        if (!isNaN(parseInt(cloneData.payin[key]))) {
          cloneData.payin[key] = parseInt(cloneData.payin[key]);
        }
      });
      Object.keys(cloneData.payout).forEach((key) => {
        if (!isNaN(parseInt(cloneData.payout[key]))) {
          cloneData.payout[key] = parseInt(cloneData.payout[key]);
        }
      });

      return cloneData;
    },
    cretaeRules(){
      this.submitting = true;
      const data = this.getFormData();
      postCustomRules(this.plusUID, data).then(({ result, data }) => {
        this.submitting = false;
        if (result) {
          this.getMainRule();
        }
      });
    },
    onSubmit() {
      this.submitting = true;
      const data = this.getFormData();
      putCustomRules(this.plusUID, data).then(({ result, data }) => {
        this.submitting = false;
        if (result) {
          this.getMainRule();
        }
      });
    },
  },
  mounted() {
    this.getMainRule();
  },
};
</script>

<style lang="scss">
.customer-rule-content {
  padding: 0;
}
</style>